import { render, staticRenderFns } from "./AddressPropertyForm.vue?vue&type=template&id=142d1e6d&"
import script from "./AddressPropertyForm.vue?vue&type=script&lang=js&"
export * from "./AddressPropertyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports